import React, { useState } from "react";

export default function NewsletterSubscribe() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  if (!email) {
    setMessage("Please enter your email.");
    return;
  }

  try {
    await fetch("https://script.google.com/macros/s/AKfycbytKjzHRYS4Yx3cSwiqBLLKsulxVIfI0KvAEtXjBgTlpA1ro5RsoBfYJ1Ur6Jxvl0F6lQ/exec", {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

    // If no error thrown, assume success
    setMessage("Thank you for subscribing!");
    setEmail("");
  } catch (error) {
    setMessage("An error occurred. Please try again.");
  }
};

  return (
    <form onSubmit={handleSubmit} className="flex items-center">
      <input
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="p-2 rounded-l-md bg-white/20 text-white placeholder-white/90 border border-white/20 focus:outline-none focus:border-green-500 transition-all duration-200"
        required
      />
      <button
        type="submit"
        className="bg-green-600 text-white p-2 rounded-r-md hover:bg-blue-700 transition"
      >
        Send
      </button>
      {message && <p className="ml-4 text-sm text-gray-300">{message}</p>}
    </form>
  );
}
